import util from '@/util/util'

export default function (lang, callback) {
  const ts = new Date().getTime()
  const languageScript = document.createElement('script')
  languageScript.setAttribute(
    'src',
    `https://www-cdn.eu.nio.com/officialsite/www-editor/${util.getEnvInfo().env}/content/page_activity_detail/${lang}.js?v=${ts}`
  )
  document.head.appendChild(languageScript)
  languageScript.onload = callback
}
